import React, { Component } from 'react';
import { Link } from 'react-router';
import withNotify from '../../common/withNotify.js';
import withLoader from '../../common/withLoader.js';
import Header from '../Header.js';

class ChooseFieldPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      objectsToDisplay: [],
      searchValue: '',
    };
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    const { objectsList } = this.props;
    const searchInput = this.inputRef.current;
    this.setState({
      objectsToDisplay: objectsList
    });
    if (searchInput) {
      searchInput.focus();
    }
  }

  _onCaseGoBack = async () => {
    try {
      // const { onGoBack } = this.props;
      // onGoBack(onGoBack);
    } catch (e) {
    }
  }

  UNSAFE_componentWillUpdate(nextProps, nextState,) {
    if (nextProps.objectsList !== this.props.objectsList) {
      nextState.objectsToDisplay = nextProps.objectsList;
      nextState.searchValue = '';

      try {
        const {
          caseData, pageTitle
        } = this.props;

        if (pageTitle === 'Type') {
          if (typeof caseData.ACMCaseID !== 'undefined' && caseData.ACMCaseID !== null) {
            nextState.objectsToDisplay = nextProps.objectsList.filter(
              (item) => item.toLowerCase().indexOf(caseData.CaseType.toLowerCase()) === 0
            );
          }
        }
      } catch (e) {

      }
    }
  }

  render() {
    const { searchValue, objectsToDisplay } = this.state;
    const {
      pageTitle, onGoBack, objectsList, onSelect, hideSearch
    } = this.props;

    const pageTitleNew = (pageTitle === 'WeightUnitType' ? 'Weight Units' : (pageTitle === 'HeightUnitType' ? 'Height Units' : pageTitle));

    return (
      <>
        <Header title={pageTitleNew} goBack={onGoBack} />
        <section>
          <section className="section">
            <div className="container">
              {
                !hideSearch && (
                  <div style={{
                    padding: '15px 10px'
                  }}
                  >
                    <input
                      type="text"
                      ref={this.inputRef}
                      className="form-control search-input-focus black-bg"
                      value={searchValue}
                      onChange={({ target: { value } }) => {
                        this.setState({
                          searchValue: value,
                          objectsToDisplay: objectsList.filter((data) => data.toLowerCase()
                            .includes(value.toLowerCase())),
                        });
                      }}
                      placeholder={`Search for a ${pageTitle}`}
                    />
                  </div>
                )
              }

              <div className="row">
                <div className="col-12">
                  <ul className="select-list list-unstyled cursor-pointer" style={{ padding: '0 10px' }}>
                    {
                      objectsToDisplay && objectsToDisplay.map((data, index) => (
                        <Link
                          key={index}
                          onClick={() => onSelect(data)}
                        >
                          <li style={{
                            borderBottom: '1px solid rgb(117, 117, 117)',
                            padding: '15px 0',
                          }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div style={{ display: 'flex', flexDirection: 'column', minWidth: '100%' }}>
                                <p style={{ margin: 0, fontWeight: '600' }}>
                                  {
                                    (pageTitle === 'HeightUnitType' || pageTitle === 'WeightUnitType')
                                      ? `${data.split(', ')[0]} (${data.split(', ').pop()})`
                                      : data
                                  }
                                </p>
                              </div>
                            </div>
                          </li>
                        </Link>
                      ))
                    }

                    {
                      objectsToDisplay.length === 0 && (
                        <li style={{ borderBottom: 'none', cursor: 'default' }}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ textAlign: 'center', width: '100%' }}>
                              No results found.
                            </div>
                          </div>
                        </li>
                      )
                    }
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </section>
      </>
    );
  }
}

export default withNotify(
  withLoader(
    ChooseFieldPage
  )
);
